import React from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { Input } from "@shadcn-in-nx/ui/input";
import { Label } from "@shadcn-in-nx/ui/label";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
} from "@shadcn-in-nx/ui/dialog";

function TableFilterDialog({
    open,
    onOpenChange,
    columnName,
    currentFilter,
    onApply,
    onClear,
}) {
    const [value, setValue] = React.useState("");

    React.useEffect(() => {
        if (open) setValue(currentFilter || "");
    }, [open, currentFilter]);

    const handleApply = () => onApply(columnName, value);
    const handleClear = () => onClear(columnName);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Filter Column: {columnName}</DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                    <div>
                        <Label htmlFor="filterValue">Filter Value</Label>
                        <Input
                            id="filterValue"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            placeholder={`Enter value to filter ${columnName}...`}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") handleApply();
                                else if (e.key === "Escape") onOpenChange(false);
                            }}
                            autoFocus
                        />
                        <p className="text-sm text-muted-foreground mt-1">
                            Shows records where {columnName} contains this value (case-insensitive)
                        </p>
                    </div>
                    {currentFilter && (
                        <div className="p-3 bg-blue-50 rounded-md">
                            <p className="text-sm text-blue-800">
                                <strong>Current filter:</strong> "{currentFilter}"
                            </p>
                        </div>
                    )}
                </div>
                <DialogFooter className="gap-2">
                    {currentFilter && (
                        <Button variant="outline" onClick={handleClear}>
                            Clear Filter
                        </Button>
                    )}
                    <Button variant="outline" onClick={() => onOpenChange(false)}>
                        Cancel
                    </Button>
                    <Button onClick={handleApply}>Apply Filter</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default React.memo(TableFilterDialog);
